import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"summary","fill":"props.strokeColor1","d":"M18.002 19.7324L16.3506 22H15.3467L16.3291 19.8574H15V17H18.002V19.7324ZM22 19.7324L20.3486 22H19.3457L20.3281 19.8574H19V17H22V19.7324ZM13 20H2V18H13V20ZM22 13H2V11H22V13ZM3.67188 4.14258H5V7H2V4.26758L3.65137 2H4.6543L3.67188 4.14258ZM7.6709 4.14258H9V7H5.99805V4.26758L7.64941 2H8.65332L7.6709 4.14258ZM22 6H11V4H22V6Z"}}]};

const Summary = Vue.extend<IconProps>({
  name: 'SummaryIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'summary',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Summary;
